<template>
  <div class="chat-content-box">
     <!-- <div class="notice-box">
          <span>2021年5月18日</span>
      </div>
      <div class="notice-box">
          <span>员工：***与客户进行沟通</span>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <p>23323232132321312233232321323213122332323213232131223323232132321312233232321323213122332323213232131223323232132321312</p>
          </div>
      </div>
      <div class="message-box staff">
          <div class="message">
            <p>23323232132321312233232321323213122332323213232131223323232132321312233232321323213122332323213232131223323232132321312</p>
          </div>
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <el-image 
                style="width: auto; height: auto"
                :src="url" 
                :preview-src-list="srcList">
            </el-image>
          </div>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <div class="file-box">
                <i class="el-icon-document"></i>
                <span>平台设计规范</span>
            </div>
          </div>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <div class="voice-box">
                <i class="arsenal_icon arsenalshengboyuyinxiaoxi"></i>
                <span>25''</span>
            </div>
          </div>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <div class="voice-box">
                <i class="arsenal_icon arsenaltelephone"></i>
                <span>通话时长 00:28</span>
            </div>
          </div>
      </div>
      <div class="message-box">
          <div class="avatar">
              <el-avatar size="small" :src="circleUrl"></el-avatar>
          </div>
          <div class="message">
            <div class="voice-box">
                <i class="arsenal_icon arsenalvideo-solid"></i>
                <span>通话时长 00:28</span>
            </div>
          </div>
      </div>-->
      <div class="dialogContent" id="messageContent" ref="msgContainer">
          <div v-for="(item, index) in messageList" :key="index">
              <el-link
                      :underline="false"
                      v-if="index == 0 && moreMessages"
                      type="primary"
                      @click="
                clickUserli(
                  askbotInfo,
                  false,
                  false,
                  item.id
                )
              "
              >更多消息</el-link
              >
              <el-link
                      :underline="false"
                      v-if="index == 0 && !moreMessages"
                      type="primary"
                      disabled
              >没有更多消息了</el-link
              >
              <div
                      class="message message-kf"
                      v-if="item.source == 'MINI_PROGRAM_WEB_SOCKET'"
              >
                  <div class="user-detail">
                      <div class="media-body">
                          <p
                                  v-if="
                      item.type == 'user_action_to_satisfaction' ||
                      item.type == 'user_action_to_unsatisfactory'
                    "
                          >
                              {{ JSON.parse(item.content).input }}
                          </p>
                          <p v-else-if="item.type == 'TEMPLATE_CARD_BUTTON'">
                              {{ JSON.parse(item.content).name }}
                          </p>

                          <p
                                  v-else
                                  v-html="
                      item.type == 'RADIO'
                        ? item.content.split('_')[
                            item.content.split('_').length - 1
                          ]
                        : item.content
                    "
                          ></p>
                          <span>{{
                    new Date(item.time).Format("yyyy-MM-dd hh:mm:s")
                  }}</span>
                      </div>
                      <div class="user-image">
                          <!-- <i class="arsenal_icon arsenalyuangong"></i> -->
                          <img src="../../../assets/images/Female_user_help.png" />
                          <span>用户</span>
                      </div>
                  </div>
              </div>

              <!--  用户满意度满意事件-->
              <div
                      class="message"
                      v-if="item.type == 'user_action_to_satisfaction'"
              >
                  <template>
                      <div
                              class="user-detail"
                              v-if="JSON.parse(item.content) != null"
                      >
                          <div class="user-image">
                              <!-- <i class="arsenal_icon arsenalyuangong"></i> -->
                              <img src="../../../assets/images/chatboticon.png" />
                              <span>BOT</span>
                          </div>
                          <!-- <div class="media-body">

                             <p v-html="JSON.parse(item.content).reply_text"></p>
                             <span>{{
                               new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                             }}</span>
                             <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                               userInfor.botName
                             }}</span>
                             <span
                               v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                               class="botname"
                               >{{ item.sourceId }}</span
                             >
                           </div>-->
                          <div class="media-body-ps"
                               v-if=" JSON.parse(item.content).reply_options != null &&
                        JSON.parse(item.content).reply_options.length > 0">
                              <p class="other" v-html="JSON.parse(item.content).reply_text"></p>
                              <p
                                      class="ps"
                                      v-if="
                        JSON.parse(item.content).reply_options != null &&
                        JSON.parse(item.content).reply_options.length > 0
                      "
                                      v-for="(option, index) in JSON.parse(item.content).reply_options"
                                      :key="index"

                              >
                                  {{ option.name }}
                              </p>
                              <span style="padding: 0 15px">{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                                      style="margin-right: 15px"
                              >{{ item.sourceId }}</span>
                          </div>
                          <div v-else class="media-body">
                              <p v-html="JSON.parse(item.content).reply_text"></p>
                              <span>{{
                        new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                      }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                        userInfor.botName
                      }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span>
                          </div>

                      </div>
                  </template>
              </div>

              <!--  用户满意度不满意按钮数据   -->
              <div
                      class="message"
                      v-if="item.type == 'user_action_to_unsatisfactory'"
              >
                  <template>
                      <div
                              class="user-detail"
                              v-if="JSON.parse(item.content) != null"
                      >
                          <div class="user-image">
                              <!-- <i class="arsenal_icon arsenalyuangong"></i> -->
                              <img src="../../../assets/images/chatboticon.png">
                              <span>BOT</span>
                          </div>
                          <div class="media-body">
                              <p
                                      class="other"
                                      v-if="JSON.parse(item.content).reply_text != null"
                              >
                                  {{ JSON.parse(item.content).reply_text }}
                              </p>
                              <p
                                      class="ps"
                                      v-if="
                        JSON.parse(item.content).reply_options != null &&
                        JSON.parse(item.content).reply_options.length > 0
                      "
                                      v-for="(option, index) in JSON.parse(item.content)
                        .options"
                                      :key="index"
                              >
                                  {{ option.name }}
                              </p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span class="botname">{{ userInfor.botName }}</span>
                          </div>
                          <!-- <div class="user-image">
                             <img src="./../../assets/images/Female_user_help.png" />
                             <span>用户</span>
                           </div>-->
                      </div>
                  </template>
              </div>
              <!-- 人工客服消息 -->
              <template v-if=" item.source === 'CUSTOMER_SERVICE_SYSTEM'">

                  <div class="message" v-if="item.type == 'TEXT' ">
                      <div class="user-detail">
                          <div class="user-image">
                              <img alt="人工客服"  src="../../../assets/images/customer_service.png" />
                              <span>客服</span>
                          </div>
                          <div class="media-body">
                              <p v-html="item.content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span
                                      v-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceName }}</span
                              >
                          </div>
                      </div>
                  </div>

                  <div class="message" v-if="item.type === 'image' ">
                      <div class="user-detail">
                          <div class="user-image">
                              <img alt="人工客服"  src="../../../assets/images/customer_service.png" />
                              <span>客服</span>
                          </div>
                          <div class="media-body">
                              <p>
                                  <el-image
                                          style="width: 35%"
                                          :src="item.content"
                                  ></el-image>
                              </p>

                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span
                                      v-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceName }}</span
                              >
                          </div>
                      </div>
                  </div>

                  <div class="message" v-if="item.type === 'video' ">
                      <div class="user-detail">
                          <div class="user-image">
                              <img alt="人工客服"  src="../../../assets/images/customer_service.png" />
                              <span>客服</span>
                          </div>
                          <div class="media-body">
                              <p>
                                  <video-player
                                          class="video-player vjs-custom-skin"
                                          :options="videoOptions({'url':item.content})"
                                  />
                              </p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span
                                      v-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceName }}</span
                              >
                          </div>
                      </div>
                  </div>


                  <div class="message" v-if="item.type === 'office_file' ||item.type === 'other_file' ">
                      <div class="user-detail">
                          <div class="user-image">
                              <img alt="人工客服"  src="../../../assets/images/customer_service.png" />
                              <span>客服</span>
                          </div>
                          <div class="media-body" >
                              <p>
                                  <file-type :urls="JSON.parse(item.content).urls"></file-type>
                              </p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span
                                      v-if="item.source === 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceName }}</span
                              >
                          </div>
                      </div>
                  </div>
              </template>

              <!-- 机器人消息 -->
              <template
                      v-if="
                (item.source == 'GUORAN_BOT'
                 ) &&
                item.type != 'user_action_to_satisfaction' &&
                item.type != 'user_action_to_unsatisfactory'
              "
              >
                  <div
                          class="message"
                          v-for="(msg, index) in JSON.parse(item.content)"
                          :key="index"
                  >
                      <div class="user-detail" v-if="msg.content != null">

                          <div class="user-image">
                              <img src="../../../assets/images/chatboticon.png" />
                              <span>BOT</span>
                          </div>
                          <div
                                  class="media-body"
                                  v-if="
                      (msg.type == 'answer_text' ||
                        msg.type == 'answer_welcometext' ||
                        msg.type == 'answer_correct') &&
                      msg.content.list != null &&
                      msg.content.list[0] != '__welcome__'
                    "
                          >
                              <p
                                      v-html="
                        msg.content.list != null ? msg.content.list[0] : ''
                      "
                              ></p>
                              <Recocell :item="msg.content"/>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  style="max-width: 325px"
                                  v-else-if="msg.type == 'answer_rich_text'"
                          >
                              <p v-html="msg.content.html"></p>
                              <Recocell :item="msg.content"/>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  style="max-width: 350px"
                                  v-else-if="msg.type == 'action_confirm_value'"
                          >
                              <TextMessage :disable="true" :text="msg.content">
                              </TextMessage>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  style="max-width: 350px"
                                  v-else-if="msg.type == 'action_alert_iframe'"
                          >
                              <ActionAlert :actionAlertIframe="msg.content"></ActionAlert>
                              <div @click="gotoAlert(msg.content.template)" class="alertUrl">{{msg.content.template}}</div>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  style="max-width: 350px"
                                  v-else-if="msg.type == 'action_form'"
                          >
                              <FormTemplate :disable="true" :formList="msg.content">
                              </FormTemplate>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  style="max-width: 350px"
                                  v-else-if="msg.type == 'action_feedback'"
                          >
                              <FeedBack
                                      :disable="true"
                                      :feedBack="msg.content"
                              ></FeedBack>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>

                          <div
                                  class="media-body"
                                  style="max-width: 350px"
                                  v-else-if="msg.type == 'answer_card_template'"
                          >
                              <TicketMessage
                                      :disable="true"
                                      :content="msg.content"
                              >
                              </TicketMessage>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>

                          <div
                                  class="media-body"
                                  v-else-if="
                      msg.type == 'action_question' &&
                      msg.content != null &&
                      msg.content.questions != null &&
                      msg.content.questions.length > 0
                    "
                          >
                              <p v-html="msg.content.questions[0]"></p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  v-else-if="msg.type == 'answer_rich_text_pro'"
                          >
                              <div v-html="msg.content.html"></div>
                              <Recocell :item="msg.content"/>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  class="media-body"
                                  v-else-if="msg.type == 'answer_image'"
                          >
                              <p>
                                  <el-image
                                          style="width: 35%"
                                          :src="msg.content.url"
                                  ></el-image>
                              </p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  v-else-if="msg.type == 'answer_radio'"
                                  class="media-body-ps"
                          >
                              <p class="other">{{ msg.content.description }}</p>
                              <p
                                      class="ps"
                                      v-for="(option, index) in msg.content.options"
                                      :key="index"
                              >
                                  {{option.name }}
                              </p>
                              <span style="margin-left: 15px; margin-top: 5px">{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname"  style="margin-top: 5px;margin-right: 15px">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"

                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div
                                  v-else-if="msg.type == 'action_satisfaction'"
                                  class="media-body-ps"
                          >
                              <p class="other">{{ msg.content.satisfactionDes }}</p>
                              <p
                                      class="ps"
                                      v-for="(option, index) in ['满意', '不满意']"
                                      :key="index"
                              >
                                  {{ option }}
                              </p>
                              <span style="margin-left: 15px; margin-top: 5px">{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname"  style="margin-top: 5px;margin-right: 15px">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"

                              >{{ item.sourceId }}</span
                              >
                          </div>

                          <div
                                  v-else-if="msg.type == 'answer_video'"
                                  class="media-body"
                          >
                              <p>
                                  <video-player
                                          v-if="msg.type === 'answer_video'"
                                          class="video-player vjs-custom-skin"
                                          :options="videoOptions(msg.content)"
                                          style="width: 350px"
                                  />
                              </p>
                              <span>{{
                      new Date(item.time).Format("yyyy-MM-dd hh:mm:ss")
                    }}</span>
                              <span v-if="item.source == 'GUORAN_BOT'" class="botname">{{
                      userInfor.botName
                    }}</span>
                              <span
                                      v-else-if="item.source == 'CUSTOMER_SERVICE_SYSTEM'"
                                      class="botname"
                              >{{ item.sourceId }}</span
                              >
                          </div>
                          <div v-else-if="msg.type == 'action_transfer'">
                              <!--                                        机器人回复为转人工组件内容 -->
                          </div>
                          <div v-else-if="msg.type ==='action_send_message_to_bot'">
                              <span>{{ msg.content.description }}</span>
                              <span
                                      v-for="(cell, index) in msg.content.options"
                                      :key="'_' + index"
                                      class="link-cell cursor"
                              >{{ cell.name }}</span>
                          </div>
                          <div v-else>
                              <p>{{ msg }}</p>
                          </div>
                      </div>
                  </div>
              </template>
          </div>
      </div>
  </div>
</template>

<script>
    import Recocell from "./Recocell";
export default {
    data () {
      return {
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
        sizeList: ["large", "medium", "small"],
        url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        srcList: [
          'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
          'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
        ],
          askbotInfo:{},
          messageList:[],
          moreMessages:false,
          userInfor:{
              user: [{ userName: "" }],
              botName:''
          }
      }
    },
    components:{Recocell},
    methods:{
        clickUserli(item,scroll,clearHistory,lastMessageId){
          console.log(item)
            this.askbotInfo=item
            let url='/open-api/message/session/history/'+item.apiKey+'/'+item.unionId+'/'+item.sessionId+'?size=11'+'&clientType=OPEN'
            if (clearHistory != null && clearHistory == true) {
                this.messageList = [];
            }
            if (lastMessageId){
                url = url + "&lastMessageId=" + lastMessageId;
            }
            this.$http.get(url).then(res=>{
                console.log('聊条记录',res)
                let userMessages = res.data.data;
                //that.userMessages = res.data;
                console.log(userMessages.length)
                if (userMessages != null) {
                    if (userMessages.length > 10) {
                        let slice = userMessages.slice(0, 10);
                        for (let i = userMessages.length - 1; i >= 0; i--) {
                            if (userMessages[i].type == null) {
                                let tampArr = JSON.parse(userMessages[i].content);
                                if (tampArr != null) {
                                    tampArr.forEach((cell) => {
                                        if (cell.type == "answer_rich_text_pro") {
                                            cell.content.html = cell.content.html.replace(
                                                /onclick="__rich_text_pro_button_onclick\(this\)"/g,
                                                ""
                                            );
                                        }
                                    });
                                }
                                userMessages[i].content = JSON.stringify(tampArr);
                            }
                            this.messageList.unshift(userMessages[i]);
                        }
                        // console.log('wwh' + that.userMessages);
                        // that.userMessages = ;
                        this.moreMessages = true;
                    } else {
                        for (let i = userMessages.length - 1; i >= 0; i--) {
                            this.messageList.unshift(userMessages[i]);
                        }
                        this.moreMessages = false;
                    }
                    console.log('聊天记录数据------',this.messageList)
                }
            })
        },
        // 将匹配结果替换表情图片
        emotion (res) {
            let word = res.replace(/\#|\;/gi,'')
            const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', '不', '可以', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
            let index = list.indexOf(word)
            return `<img height="20px" src="https://guoranim.oss-cn-beijing.aliyuncs.com/emoji/${index+1}.png" align="middle">`
        },
        videoOptions(videoContent) {
            console.log(videoContent);
            return {
                muted: true,
                language: "en",
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [
                    {
                        type: "video/mp4",
                        src: videoContent.url?videoContent.url:videoContent,
                    },
                ],
                width: "350",
                height: "160",
            };
        },
        gotoAlert(url){
            window.open(url);
        },
    }
}
</script>

<style lang="less" scoped>
.chat-content-box{
    padding: 20px 20px 20px 10px;
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    color: #606266;
    .notice-box{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0px;
        span{
            font-size: 10px;
            color: #9e9e9e;
            padding: 5px 10px;
            background-color: #e6e6e6 !important;
            border-radius: 5px;
        }
    }
    .message-box{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;
        .avatar{
            margin: 0px 10px;
        }
        .message{
            border: 1px solid #d7dae2;
            border-radius: 0px 15px 15px 15px;
            padding: 10px;
            max-width: 70%;
            p{
                word-wrap:break-word;
                word-break:normal;
                line-height: 25px;
                color: #606266;
            }
            .el-image{
                max-height: 500px;
            }
            .file-box{
                i{
                    margin-right: 5px;
                }
            }
        }
    }
    .staff{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        margin-bottom: 20px;
        .avatar{
            margin: 0px 10px;
        }
        .message{
            background-color: #409eff;
            border: 1px solid #d7dae2;
            border-radius: 15px 0px 15px 15px;
            padding: 10px;
            max-width: 70%;
            p{
                word-wrap:break-word;
                word-break:normal;
                line-height: 25px;
                color: #ffffff;
            }
        }
    }
    .dialogContent{
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: auto;
        .el-link{
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .message-notice{
            display: inline-block;
            text-align: center;
            margin-bottom: 20px;
            width: 100%;
            background-color: transparent !important;
        }
        .notice-content{
            display: inline-block;
            padding: 5px 10px;
            border-radius: 5px;
            background-color: #e8eaec;
            color: #666666;
            font-size: 12px;
        }
        .notice-content-day{
            display: inline-block;
            padding: 5px 10px;
            .line-left{
                display:inline-block;
                width:100px;
                height:1px;
                margin-bottom: 5px;
                margin-right: 5px;
                //background:#dcdcdc;
                background: -webkit-linear-gradient(left, #fff -4%,#666666 50%);

            }
            .line-text{
                color: #666666;
                font-size: 12px;
            }
            .line-right{
                display:inline-block;
                width:100px;
                height:1px;
                margin-bottom: 5px;
                margin-left: 5px;
                //background:#dcdcdc;
                background: -webkit-linear-gradient(left,#666666 50%,#fff 100%);
            }
        }
        //messages
        .message{
            display: flex;
            margin-bottom: 20px;
            justify-content:flex-start;
            .user-detail{
                display: flex;
                -ms-flex-align: flex-start;
                align-items: flex-start;
                .media-body{
                    //max-width: calc(100vw - 800px);
                    background-color: #f5f5f5;
                    // border: 1px solid #e4e3e3;
                    word-break: break-word;
                    flex: 1;
                    min-height: 25px;
                    line-height: 25px;
                    border-radius: 15px;
                    border-top-left-radius: 0px;
                    padding: 10px 10px 0 15px;
                    text-align: left;

                    h2{
                        font-size: 18px;
                    }
                    p{
                        margin-bottom: 5px;
                        font-size: 14px;
                        word-wrap:break-word;
                        word-break:break-all;
                        overflow: hidden;
                        display: flex;
                        flex-wrap:wrap;
                    }
                    .content{
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                    }
                    .voicemessage{
                        width: 200px;
                        height: 35px;
                        line-height: 35px;
                        background-color: #e8eaec;
                        border-radius: 10px;
                        .icon-vioce{
                            font-size: 24px;
                            float: left;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                        .time{
                            font-size: 14px;
                            margin-left: 20px;
                        }
                    }
                    span{
                        margin-bottom: 5px;
                        font-size: 12px;
                        color: #a3a4a5;
                        float: left;
                    }
                    .botname{
                        margin-left: 10px;
                        float: right;
                    }
                    .mb-0{
                        margin-bottom: 0 !important;
                        text-align: left;
                        line-height: 1.3;
                        margin-top: 0;
                        font-size: 12px;
                    }
                }
                .user-image{
                    width: 35px;
                    height: 35px;
                    margin-left: 10px;
                    margin-right: 10px;
                    img{
                        width: 35px;
                        height: 35px;
                    }
                    span{
                        color: #666666;
                        font-size: 12px;
                    }
                    /* 用户头像背景颜色 */
                    // .web{
                    //     background-color: #00BCD4 !important;
                    // }
                    // .mobile{
                    //     background-color: #409eff !important;
                    // }
                    // .qichat{
                    //     background-color: #1AAD19 !important;
                    // }
                    // .app{
                    //     background-color: #FF9900 !important;
                    // }
                    // .miniapp{
                    //     background-color: #FFFF00 !important;
                    // }
                    // .offline{
                    //     background-color: #f2f2f2 !important;
                    //     color: #666666 !important;
                    // }
                }
                .media-body-ps{
                    //max-width: calc(100vw - 800px);
                    background-color: #f8f8f8;
                    border: 1px solid #e4e3e3;
                    word-break: break-word;
                    flex: 1;
                    min-height: 25px;
                    line-height: 25px;
                    border-radius: 25px;
                    border-top-left-radius: 0px;
                    text-align: left;
                    h2{
                        font-size: 18px;
                    }
                    .other{
                        margin-bottom: 5px;
                        font-size: 14px;
                        word-wrap:break-word;
                        word-break:break-all;
                        overflow: hidden;
                        padding: 10px 10px 0 15px;
                    }
                    .ps{
                        padding: 5px 10px 5px 15px;
                        height: 25px;
                        line-height: 25px;
                        border-top: 1px solid #e4e3e3;
                        background-color: #ffffff;
                        color: #409eff;
                        cursor:pointer;
                    }
                    .end{
                        border-bottom-left-radius: 25px !important;
                        border-bottom-right-radius: 25px !important;
                    }
                    .voicemessage{
                        width: 200px;
                        height: 35px;
                        line-height: 35px;
                        background-color: #e8eaec;
                        border-radius: 10px;
                        .icon-vioce{
                            font-size: 24px;
                            float: left;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                        .time{
                            font-size: 14px;
                            margin-left: 20px;
                        }
                    }
                    span{
                        margin-bottom: 5px;
                        font-size: 12px;
                        color: #a3a4a5;
                        float: left;
                    }
                    .botname{
                        margin-left: 10px;
                        float: right;
                    }
                    .mb-0{
                        margin-bottom: 0 !important;
                        text-align: left;
                        line-height: 1.3;
                        margin-top: 0;
                        font-size: 12px;
                    }
                }
            }
            .video-player ,.video-js .vjs-icon-placeholder {
                width: 300px;
                height: 172px;
                display: block;
            }
            .el-image{
                float:right;
                width: 300px !important;
                height: auto !important;
            }
        }
        .message-kf{
            display: flex;
            margin-bottom: 20px;
            justify-content:flex-end;
            .user-detail{
                display: flex;
                -ms-flex-align: flex-start;
                align-items: flex-start;
                .media-body{
                    //max-width: calc(100vw - 800px);
                    border:  1px solid #c1e5ff !important;
                    background-color: #c1e5ff !important;
                    word-break: break-word;
                    flex: 1;
                    min-height: 25px;
                    line-height: 25px;
                    border-radius: 15px;
                    border-top-right-radius: 0px;
                    padding: 10px 10px 0 10px;
                    text-align: left;
                    h2{
                        font-size: 18px;
                    }
                    p{
                        margin-bottom: 5px;
                        font-size: 14px;
                        word-wrap:break-word;
                        word-break:break-all;
                        overflow: hidden;
                    }
                    .voicemessage{
                        width: 200px;
                        height: 35px;
                        line-height: 35px;
                        background-color: #e8eaec;
                        border-radius: 10px;
                        .icon-vioce{
                            font-size: 24px;
                            float: left;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                        .time{
                            font-size: 14px;
                            margin-left: 20px;
                        }
                    }
                    span{
                        margin-bottom: 5px;
                        font-size: 12px;
                        color: #a3a4a5;
                        float: right;
                    }
                    .botname{
                        margin-left: 10px;
                        float: right;
                    }
                    .mb-0{
                        margin-bottom: 0 !important;
                        text-align: left;
                        line-height: 1.3;
                        margin-top: 0;
                        font-size: 12px;
                    }
                }
            }
            .video-player ,.video-js .vjs-icon-placeholder {
                width: 300px;
                height: 172px;
                display: block;
            }
            .el-image{
                float:right;
                width: 300px !important;
                height: auto !important;
            }
        }
    }
}
</style>